import { isDev, isStaging } from '@utils/isProd';

const DRUMKIT_AUTH_URL =
  process.env.DRUMKIT_AUTH_URL ??
  (isDev()
    ? 'http://localhost:5173'
    : isStaging()
      ? 'https://app-staging.drumkit.ai'
      : 'https://app.drumkit.ai');

export default DRUMKIT_AUTH_URL;
